
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/companies",
      function () {
        return require("private-next-pages/sitemap/companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/companies"])
      });
    }
  